module.exports = __webpack_public_path__ + "img/google.8142aaf9.png";